import { render, staticRenderFns } from "./resumenCliente.vue?vue&type=template&id=408ed1be&"
import script from "./resumenCliente.vue?vue&type=script&lang=js&"
export * from "./resumenCliente.vue?vue&type=script&lang=js&"
import style0 from "./resumenCliente.vue?vue&type=style&index=0&id=408ed1be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports